export const TOKEN_TYPES = {
  CARDS_SENSITIVE: 'cards_sensitive_token',
  CARDS_SENSITIVE_WRITE: 'cards_sensitive_write_token',
  COMMON: 'common_token',
  MOBILE_CHECK_DEPOSITS: 'mobile_check_deposits_token'
};

export const MOBILE_CHECK_DEPOSITS_SCOPE = ['accounts', 'check_deposits_write'];

export const CARDS_SENSITIVE_SCOPE = ['cards', 'cards_sensitive'];
export const CARDS_SENSITIVE_WRITE_SCOPE = ['cards_sensitive_write'];
export const COMMON_SCOPES = [
  'accounts',
  'payments',
  'cards',
  'cards_write',
  'counterparties',
  'counterparties_write',
  'payments_write_counterparty',
  'statements',
  'check_deposits',
  'check_deposits_write',
  'payments_write'
];

export const ZB_SESSION_CLAIMS_COOKIE = 'idePrf';

export const TOKEN_ATTRIBUTES = {
  IDEMPOTENCY_KEY: 'https://www.zenbusiness.com/idempotencyKey',
  IAT: 'iat'
};
